import { render, staticRenderFns } from "./DebtSummary.vue?vue&type=template&id=04e73f11&scoped=true&"
import script from "./DebtSummary.vue?vue&type=script&lang=js&"
export * from "./DebtSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e73f11",
  null
  
)

export default component.exports